import {
	ChatBubbleLeftRightIcon,
	ListBulletIcon,
} from '@heroicons/vue/16/solid';
import {
	ClipboardDocumentCheckIcon,
	IdentificationIcon,
	TrophyIcon,
} from '@heroicons/vue/24/solid';

/**
 * The Your Journey stages in display order, keyed by `App\Enum\JourneyStage`. The stage track and
 * Change Focus show the same name and icon for each.
 *
 * The design mixes two heroicons sets, each drawn at 20px: micro for Resume and Interviews (as in
 * the sidebar), 24px solid for the rest.
 */
export const JOURNEY_STAGES = [
	{ key: 'profile', name: 'Target Role & Profile', icon: IdentificationIcon },
	{ key: 'resume', name: 'Resume', icon: ListBulletIcon },
	{ key: 'application', name: 'Application', icon: ClipboardDocumentCheckIcon },
	{ key: 'interviews', name: 'Interviews', icon: ChatBubbleLeftRightIcon },
	{ key: 'offer', name: 'Offer', icon: TrophyIcon },
];
